// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Zc5s","col":"Table_col__1v7dV","fulfillmentStatus":"Table_fulfillmentStatus__2rQ96","emailCol":"Table_emailCol__3D3f-"};